<template>
  <ElTable :data="receipts" :empty-text="$t('ACCOUNT.STATUS.NO_DATA')">
    <ElTableColumn :label="$t('ACCOUNT.STATUS.RECEIPT_AMOUNT')">
      <template slot-scope="{ row: { amount } }">
        {{ currencyFormat(amount) }} {{ $t('RIALS') }}
      </template>
    </ElTableColumn>

    <ElTableColumn :label="$t('ACCOUNT.STATUS.RECEIPT_DATE')" prop="date">
      <template slot-scope="{ row: { date } }">
        {{ translateDate(date) }}
      </template>
    </ElTableColumn>
    <ElTableColumn :label="$t('ACCOUNT.STATUS.RECEIPT_TOKEN')" prop="token" />

    <ElTableColumn v-slot="{ row }" width="180">
      <div v-if="row.factor_number" class="text-left">
        <ElButton
          icon="el-icon-document"
          size="small"
          plain
          @click="downloadReceipt(row.factor_number)"
        >
          {{ $t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_INVOICE_FACTOR') }}
        </ElButton>
      </div>
    </ElTableColumn>
  </ElTable>
</template>

<script>
import { format as currencyFormat } from '@/utils/number';
import { dateFormat } from '@/utils/date';

import lang from '@/mixins/lang';
import { Membership } from '@/api/api';
import FileSaver from 'file-saver';

export default {
  name: 'ReceiptsTable',
  mixins: [lang],
  props: {
    receipts: {
      type: Array,
      required: true,
    },
  },
  methods: {
    currencyFormat,
    translateDate(date) {
      if (!date) return '-';

      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      return dateFormat('YYYY/M/D')(toFormat)(date);
    },
    downloadReceipt(key) {
      const fileName = `pishkhan_factor_${key}.pdf`;

      return Membership.getReceiptFile({ type: key })
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/pdf',
          });
          FileSaver.saveAs(blob, fileName);
        })
        .catch(({ body: { message } = {} }) => {
          this.$message.error(message || this.$t('API_ERROR'));
        });
    },
  },
};
</script>

<style></style>
